import { AllowedAction } from '@/modules/common/types/allowed-actions';
import { IntegrationServices } from '@/modules/common/types/integrations';

export enum TeamMemberChangeType {
  Info = 'info',
  Billing = 'billing',
  Capacity = 'capacity',
  Integration = 'integration',
}

export interface TeamMemberChangedField {
  field: string;
  fieldLocalizedName: string | null;
  from: string | null;
  to: string | null;
  subfieldChanges: TeamMemberChangedField[] | null;
  isGrouped?: boolean;
  groupCount?: number;
}

export interface TeamMemberChangedBy {
  id: number;
  name: string;
  profileImageUrl: string | null;
  isIntegration: boolean;
  integrationProvider?: IntegrationServices;
}

export interface TeamMemberChangeLogEntry {
  id: number;
  type: TeamMemberChangeType;
  startDate: string;
  endDate: string | null;
  changedBy: TeamMemberChangedBy;
  changedFields: TeamMemberChangedField[];
  allowedActions: AllowedAction[];
  isActive: boolean;
  /** Whether this change represents when the team member was first added */
  isInitialChange: boolean;
}
